import {
  Layout_Page_Bottoms_Enum,
  Layout_Pages_Enum,
  Order_By,
  useGetCategoryBySlugQuery,
} from '@/generated/graphql';
import { useRouter } from 'next/router';
import React, { useMemo } from 'react';
import {
  BeautifulHouseCategory,
  LargeCategory,
  SmallCategory,
} from '../Category';
import { SEOConfig } from 'next-seo.config';

const DetailCategoryPage = () => {
  const router = useRouter();
  const { query } = router;
  const fullSlug = useMemo(
    () => (query?.slug as string[])?.join('/'),
    [query?.slug],
  );
  const { data } = useGetCategoryBySlugQuery({
    variables: {
      where: {
        path_full_slug: {
          full_slug: {
            _eq: fullSlug,
          },
        },
      },
      allPostsLimit: 6,
      allPostsOrderBy: [
        {
          is_hot: Order_By.DescNullsLast,
        },
        { pin_at: Order_By.DescNullsLast },
        { published_at: Order_By.DescNullsLast },
      ],
      allPostsWhere: {
        published_at: {
          _is_null: false,
          _lte: 'now()',
        },
      },
      allPostsChildLimit: 6,
      allPostsChildOrderBy: {
        published_at: Order_By.Desc,
      },
    },
  });

  const { layoutPage, name, layoutPageBottom } = data?.categories[0] || {};

  const renderSection = useMemo(() => {
    switch (layoutPage) {
      case Layout_Pages_Enum.BeautifulHouses:
        return <BeautifulHouseCategory data={data} />;
      case Layout_Pages_Enum.Normal:
        if (layoutPageBottom === Layout_Page_Bottoms_Enum.ListCategories)
          return <LargeCategory data={data} />;
        else return <SmallCategory data={data} />;
      default:
        return <SmallCategory data={data} />;
    }
  }, [data, layoutPage, layoutPageBottom]);

  return (
    <>
      <SEOConfig
        {...{
          title: `${name} | Tin Hay Nhà Đất`,
          urlLink: `${process.env.NEXT_PUBLIC_WEBSITE_URL}${router.asPath}`,
        }}
      />
      {renderSection}
    </>
  );
};

export default DetailCategoryPage;
